// extracted by mini-css-extract-plugin
export default {"tasksPage":"ProjectTasksPage_tasksPage__a84y5","tasksGrid":"ProjectTasksPage_tasksGrid__TIy4A","task":"ProjectTasksPage_task__EY9hM","project":"ProjectTasksPage_project__kS5W2"};